'use client'
import React, { useState } from 'react';

const page = () => {
  const [activeTab, setActiveTab] = useState('calender');

  return (
    <>
      <section className="faq__area-6 hero__about pt-120 ">
        <div className="container g-0  pt-120 pb-120">
          {/* <div className="line-3" /> */}
          <div className="row flex">
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6">
              <div className="sec-title-wrapper">
                <h1 className="sec-title-2 ">FAQs</h1>
                <p>
                  Get quick and simple answers to common questions about our services. Learn more about how we build, design, and support your projects.
                </p>
              </div>
            </div>
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 flex justify-end">
              <div className="img-wrapper">
                <img loading="lazy" decoding="async"
                  src="/assets/images/jbcodeapp_faqs.webp"
                  alt="JBcodeapp faqs"
                  className=""
                />
              </div>
            </div>

          </div>

          <div className="container">
            <h2 className='text-center md:mt-[-4%] pb-4'>How Can We Help You?</h2>
            <div className="row">
              <div className="flex flex-wrap justify-center space-x-2 py-2">
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 sm:mb-0 ${activeTab === 'calender' ? `bg-black text-white` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('calender')}
                >
                  General Faqs
                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 sm:mb-0 ${activeTab === 'game' ? `bg-black text-white` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('game')}
                >
                  Web Development
                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 sm:mb-0 ${activeTab === 'mobile' ? `bg-black text-white` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('mobile')}
                >
                  Mobile Development
                </button>
              </div>
              <div className="col-xxl-12">
                <div className=" showcase-mixitup mt-5">

                  {/* Frontend */}
                  {activeTab === 'calender' && (
                    <>
                      {/* FAQ area start */}
                      <section className="faq__area-6">
                        <div className="container g-0  pb-0">

                          <div className="row">
                            <div className="col-xxl-12">
                              <div className="faq__list-6">
                                <div className="accordion" id="accordionExample">

                                  <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingOne">
                                      <button
                                        className="accordion-button "
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseOne"
                                        aria-expanded="true"
                                        aria-controls="collapseOne"
                                      >
                                        What are JBcodeapp’s main skills and experience?
                                      </button>
                                    </h2>
                                    <div
                                      id="collapseOne"
                                      className="accordion-collapse collapse show"
                                      aria-labelledby="headingOne"
                                      data-bs-parent="#accordionExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          JBcodeapp excels in web development, mobile app development, UI/UX design, AI/ML integration, and digital marketing. Since our founding in 2019 , we have evolved from basic web development to offering cutting-edge solutions in mobile apps and AI technologies, backed by over two decades of expertise.
                                        </p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingTwo">
                                      <button
                                        className="accordion-button  collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseTwo"
                                        aria-expanded="false"
                                        aria-controls="collapseTwo"
                                      >
                                        Does JBcodeapp offer paid support after a project is finished?
                                      </button>
                                    </h2>
                                    <div
                                      id="collapseTwo"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="headingTwo"
                                      data-bs-parent="#accordionExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Yes, JBcodeapp offers paid support services after project completion. The specifics of the support depend on your project's requirements. We provide tailored support packages to ensure ongoing assistance and satisfaction with our digital solutions.
                                        </p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingThree">
                                      <button
                                        className="accordion-button  collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseThree"
                                        aria-expanded="false"
                                        aria-controls="collapseThree"
                                      >
                                        How does JBcodeapp protect the confidentiality of my idea?
                                      </button>
                                    </h2>
                                    <div
                                      id="collapseThree"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="headingThree"
                                      data-bs-parent="#accordionExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          JBcodeapp prioritizes the confidentiality of your ideas by implementing strict security measures. We sign a Non-Disclosure Agreement (NDA) before any discussions and maintain rigorous internal protocols to protect your information throughout the development process.
                                        </p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingFour">
                                      <button
                                        className="accordion-button  collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseFour"
                                        aria-expanded="false"
                                        aria-controls="collapseFour"
                                      >
                                        What is JBcodeapp’s process for developing projects?
                                      </button>
                                    </h2>
                                    <div
                                      id="collapseFour"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="headingFour"
                                      data-bs-parent="#accordionExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Our development process is comprehensive and adaptable, including requirements gathering, solution consulting, wireframing, UI/UX design, development, and thorough testing. This approach ensures that we tailor our services to meet your project's specific needs and deliver optimal results.
                                        </p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingFive">
                                      <button
                                        className="accordion-button  collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseFive"
                                        aria-expanded="false"
                                        aria-controls="collapseFive"
                                      >
                                        Does JBcodeapp work according to the client’s time zone?
                                      </button>
                                    </h2>
                                    <div
                                      id="collapseFive"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="headingFive"
                                      data-bs-parent="#accordionExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          JBcodeapp is flexible and can adjust working hours to align with your time zone for meetings or urgent tasks, given sufficient notice. This flexibility helps us maintain effective communication and meet project deadlines.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </section>
                      {/* FAQ area end */}
                    </>
                  )}

                  {/* Backend */}
                  {activeTab === 'game' && (
                    <>
                      {/* FAQ area start */}
                      <section className="faq__area-6">
                        <div className="container g-0  pb-0">

                          <div className="row">
                            <div className="col-xxl-12">
                              <div className="faq__list-6">
                                <div className="accordion" id="accordionExample">

                                  <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingThirtyone">
                                      <button
                                        className="accordion-button "
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseThirtyone"
                                        aria-expanded="true"
                                        aria-controls="Eleven"
                                      >
                                        What is web development?
                                      </button>
                                    </h2>
                                    <div
                                      id="collapseThirtyone"
                                      className="accordion-collapse collapse show"
                                      aria-labelledby="headingThirtyone"
                                      data-bs-parent="#accordionExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Web development involves creating and maintaining websites or web applications. It encompasses everything from designing the layout and structure to writing the code that powers the functionality and user interactions of the site.
                                        </p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingThirtytwo">
                                      <button
                                        className="accordion-button  collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseThirtytwo"
                                        aria-expanded="false"
                                        aria-controls="collapseThirtytwo"
                                      >
                                        What is a web portal, and why is it useful?
                                      </button>
                                    </h2>
                                    <div
                                      id="collapseThirtytwo"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="headingThirtytwo"
                                      data-bs-parent="#accordionExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          A web portal is a special type of website that brings together information from various sources into one place. Each section of the portal shows information from different sources, making it easy to access everything you need. Modern web portals offer a user-friendly experience and help organize information efficiently, providing a better way to manage and access data.
                                        </p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingThirtythree">
                                      <button
                                        className="accordion-button  collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseThirtythree"
                                        aria-expanded="false"
                                        aria-controls="collapseThirtythree"
                                      >
                                        How do you ensure the quality of your projects?
                                      </button>
                                    </h2>
                                    <div
                                      id="collapseThirtythree"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="headingThirtythree"
                                      data-bs-parent="#accordionExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          We have a dedicated team for Quality Assurance (QA) and Quality Control (QC) that puts every project through thorough testing. This includes checking the user interface, compatibility across browsers, and overall functionality on different devices. We also review the code manually and with special tools to ensure everything works perfectly before launching the final product.
                                        </p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingThirtyfour">
                                      <button
                                        className="accordion-button  collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseThirtyfour"
                                        aria-expanded="false"
                                        aria-controls="collapseThirtyfour"
                                      >
                                        How long does it typically take to develop a website?
                                      </button>
                                    </h2>
                                    <div
                                      id="collapseThirtyfour"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="headingThirtyfour"
                                      data-bs-parent="#accordionExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          The time it takes to develop a website depends on its complexity. Simple websites usually take less time, while more complex sites like eCommerce platforms require more time to develop. Factors like design complexity and specific features also affect the timeline. On average, static websites are quicker to build than dynamic ones with advanced functionality.
                                        </p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingThirtyfifth">
                                      <button
                                        className="accordion-button  collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseThirtyfifth"
                                        aria-expanded="false"
                                        aria-controls="collapseThirtyfifth"
                                      >
                                        What sets your web development services apart?
                                      </button>
                                    </h2>
                                    <div
                                      id="collapseThirtyfifth"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="headingThirtyfifth"
                                      data-bs-parent="#accordionExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Our web development services are known for delivering high-quality results at competitive prices. Whether you need a basic website or a complex <a href='/services/web/ecommerce-solution-india/'>eCommerce platform</a>, we bring expertise and dedication to every project. We focus on providing exceptional value and ensuring that each project meets high standards of performance and reliability.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </section>
                      {/* FAQ area end */}
                    </>
                  )}

                  {/* Backend */}
                  {activeTab === 'mobile' && (
                    <>
                      {/* FAQ area start */}
                      <section className="faq__area-6">
                        <div className="container g-0  pb-0">

                          <div className="row">
                            <div className="col-xxl-12">
                              <div className="faq__list-6">
                                <div className="accordion" id="accordionExample">

                                  <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingFourtyOne">
                                      <button
                                        className="accordion-button "
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseFourtyOne"
                                        aria-expanded="true"
                                        aria-controls="Eleven"
                                      >
                                        Do you develop mobile apps for all platforms?
                                      </button>
                                    </h2>
                                    <div
                                      id="collapseFourtyOne"
                                      className="accordion-collapse collapse show"
                                      aria-labelledby="headingFourtyOne"
                                      data-bs-parent="#accordionExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Yes, we create mobile applications for all major platforms, including iOS, Android, BlackBerry, Symbian, and Windows Mobile. Whether you need an app for a single platform or multiple ones, we can develop it to meet your needs.
                                        </p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingFourtytwo">
                                      <button
                                        className="accordion-button  collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseFourtytwo"
                                        aria-expanded="false"
                                        aria-controls="collapseFourtytwo"
                                      >
                                        What about the revenue potential of my app?
                                      </button>
                                    </h2>
                                    <div
                                      id="collapseFourtytwo"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="headingFourtytwo"
                                      data-bs-parent="#accordionExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          We don’t have control over app revenue, but we can offer advice and analysis to help maximize your app’s market potential. Our experts can provide insights and strategies to improve your app’s chances of success in the market.
                                        </p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingFourtythree">
                                      <button
                                        className="accordion-button  collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseFourtythree"
                                        aria-expanded="false"
                                        aria-controls="collapseFourtythree"
                                      >
                                        Are you open to partnering on app development?
                                      </button>
                                    </h2>
                                    <div
                                      id="collapseFourtythree"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="headingFourtythree"
                                      data-bs-parent="#accordionExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Yes, we are open to partnership opportunities. We have a history of successful collaborations with global partners and are keen to establish long-term business relationships that benefit both parties.
                                        </p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingFourtyfour">
                                      <button
                                        className="accordion-button  collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseFourtyfour"
                                        aria-expanded="false"
                                        aria-controls="collapseFourtyfour"
                                      >
                                        What if I need changes to the app after it's launched?
                                      </button>
                                    </h2>
                                    <div
                                      id="collapseFourtyfour"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="headingFourtyfour"
                                      data-bs-parent="#accordionExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Changes after launch may incur additional costs. To minimize extra expenses and delays, it’s best to clearly define the project scope and requirements before development begins. This helps ensure that the final product meets your expectations.
                                        </p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingFourtyfive">
                                      <button
                                        className="accordion-button  collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseFourtyfive"
                                        aria-expanded="false"
                                        aria-controls="collapseFourtyfive"
                                      >
                                        What framework or programming language do you use for app development?
                                      </button>
                                    </h2>
                                    <div
                                      id="collapseFourtyfive"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="headingFourtyfive"
                                      data-bs-parent="#accordionExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          The choice of framework or programming language depends on the platform. For iOS apps, we use tools like Swift and Xcode, while for Android, we use Android SDK. We also work with various open-source and proprietary technologies based on project needs.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </section>
                      {/* FAQ area end */}
                    </>
                  )}

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* CTA area start */}
      <section className="faq__btm">
        <div className="container  pb-130">
          {/* <div className="line-3" /> */}
          <div className="row">
            <div className="col-xxl-12">
              <div className="sec-title-wrapper">
                <h2 className="sec-title ">Still you have question?</h2>
                <p className="sub-title-anim ">
                  Contact us for assistance and we'll help you find <br />the information you're looking for.
                </p>
                <div className="btn_wrapper">
                  <a
                    href="/contact/"
                    className="wc-btn-primary btn-hover btn-item"
                  >
                    <span />
                    Contact Us <i className="fa-solid fa-arrow-right" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* CTA area end */}
    </>
  )
}

export default page;